import { MICRO_AUTH_URL } from "../helpers/Setting";

export const MicroAuth = async ({ body, token }) => {
  return await fetch(MICRO_AUTH_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token ? "Bearer " + token : ""
    },
    body: body
  }).then(res => res.json());
  // .then(res => {
  //   if (!res.data) throw res.errors;
  //   return res.data;
  // });
};
export default MicroAuth;
